module.exports = __webpack_public_path__ + "static/media/HeroImage.6782de50.png";